import { createSelector } from 'reselect';
import { Selectors } from '@grandvisionhq/configurator';
import { getFrameSku } from '../configurator/selectors.js';
import { getFrames } from '../products/selectors.internal.js';

const stepMapping = {
    lensType: 'LensType',
    prescription: 'LensPrescription',
    prescriptionValidation: 'LensReview',
    lensPackage: 'LensBundle',
    lensAddOn: 'Addons'
};
const getProduct = createSelector(getFrameSku, getFrames, (frameSku, frames)=>{
    if (!frameSku) {
        return undefined;
    }
    const frame = frames[frameSku];
    if (!frame) {
        return undefined;
    }
    return frame;
});
const getConfigFlow = createSelector(Selectors.getCurrentStep, (stepData)=>{
    /**
     * Should only occur on programmer error. We should always have this data available.
     */ if (!stepData) {
        return undefined;
    }
    return {
        version: '1.0',
        stepName: stepMapping[stepData.name]
    };
});

export { getConfigFlow, getProduct };
//# sourceMappingURL=selectors.js.map
